import { InputNumberProps } from 'antd';
import isEqual from 'lodash/isEqual';
import React, { FC, useEffect, useState } from 'react';
import { InputNumber } from 'components/atoms/input';

export const NumberField: FC<InputNumberProps> = (props) => {
  const { value, onChange } = props;
  const [state, setState] = useState<number | undefined>();

  useEffect(() => {
    setState(value);
  }, [value]);

  const commit = (v: string) => {
    const selected = v.length === 0 ? null : Number(v);

    if (!isEqual(selected, value)) {
      if (onChange) {
        onChange(selected);
      }
    }
  };

  return (
    <InputNumber
      {...props}
      onChange={(v) => setState(v != null ? Number(v) : undefined)}
      onPressEnter={(e) => e.currentTarget.blur()}
      onBlur={(e) => commit(e.currentTarget.value)}
      value={state}
      type="number"
    />
  );
};
